import React from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import moment from 'moment'
import momentLocalizer from 'react-widgets-moment'
import DatePicker from 'react-datepicker'

new momentLocalizer(moment)
const DatePickerTextArea = ({ value, onClick, disabled }) => (
  <ReactBootstrap.Form.Group className="form-group">
    <input
      disabled={disabled}
      defaultValue={value}
      className="form-control"
      onClick={onClick}
    />
  </ReactBootstrap.Form.Group>
)
export const renderDatePicker = ({
  input: { onChange, value },
  label,
  holidays,
  disabled,
  minDate,
}) => {
  let dateFormat = 'yyyy-MM-dd'
  const isWeekday = (date) => {

    const formatted_date = `${date.getFullYear()}-${date.getMonth() + 1
      }-${date.getDate()}`
    const is_holiday = holidays && holidays.includes(formatted_date)
    return !is_holiday
  }
  return (
    <ReactBootstrap.Form.Group className={'mt-3 mb-3'}>
      <label>{label}</label>
      <div>
        {minDate ? (
          <DatePicker
            showIcon
            showTimeSelect={false}
            selected={!value ? null : new Date(value)}
            onChange={onChange}
            calendarClassName="form-control"
            customInput={<DatePickerTextArea />}
            disabled={disabled}
            filterDate={isWeekday}
            dateFormat={dateFormat}
          />
        ) : (
          <DatePicker
            showIcon
            showTimeSelect={false}
            selected={!value ? null : new Date(value)}
            onChange={onChange}
            calendarClassName="form-control"
            customInput={<DatePickerTextArea />}
            disabled={disabled}
            minDate={new Date()}
            filterDate={isWeekday}
            dateFormat={dateFormat}
          />
        )}
      </div>
    </ReactBootstrap.Form.Group>
  )
}
